import { useEffect } from 'react';

/**
 * Hook que suprime el warning de React DevTools "Cannot send a message through a Bridge that has been shut down"
 * Este es un bug conocido de React DevTools, no afecta la funcionalidad de la app
 * 
 * Uso: 
 * import useSuppressDevToolsWarning from '../../hooks/useSuppressDevToolsWarning';
 * 
 * export default function MyComponent() {
 *   useSuppressDevToolsWarning();
 *   // ... resto del componente
 * }
 */
export const useSuppressDevToolsWarning = () => {
  useEffect(() => {
    // Guardar la función original de error
    const originalError = console.error;

    // Reemplazar console.error temporalmente
    console.error = function(...args) {
      const hasDevToolsError = args.some(arg => 
        typeof arg === 'string' && arg.includes('Cannot send a message through a Bridge that has been shut down')
      );

      // Solo ignorar el error específico de DevTools
      if (hasDevToolsError) {
        return;
      }

      // Para cualquier otro error, usar console.error normal
      originalError.apply(console, args);
    };

    // Cleanup: restaurar console.error al desmontar
    return () => {
      console.error = originalError;
    };
  }, []);
};
